// Typelizer digest de652cb6fac3b42cb1c0b617ca2d9565
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /houses/filter */
  filter: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/houses/filter', {}, options),
    method: 'get',
  }),

  /** GET /houses/export_excel */
  exportExcel: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/houses/export_excel', {}, options),
    method: 'get',
  }),

  /** GET /houses */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/houses', {}, options),
    method: 'get',
  }),

  /** POST /houses */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/houses', {}, options),
    method: 'post',
  }),

  /** GET /houses/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/houses/new', {}, options),
    method: 'get',
  }),

  /** GET /houses/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/houses/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /houses/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/houses/:id', params, options),
    method: 'get',
  }),

  /** PATCH /houses/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/houses/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /houses/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/houses/:id', params, options),
    method: 'delete',
  }),
}
